module.exports = "<span ng-bind=\"vm.getMessage()\"></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer.common/components/campaign-type/campaignType.html
// module id = 28
// module chunks = 0 1 3 4